<template>
  <div class="rhs">
    <div class="heading large" :class="{agent: magent}">
      {{ title }}
    </div>
    <contacts-panel agentsOnly :region="region" :columns="3" showroll hidetel :agent="magent" v-on:sendEmail="reallySendEmail"></contacts-panel>
    <div class="callus">
      <div class="strong" v-if="!magent">{{ $nippets.quote.callus }}</div>
      <div class="strong" v-if="magent">{{ $nippets.quote.callme }}</div>
      <div><a :href="'tel:'  + $nippets.tel.code">{{ $nippets.tel.display }}</a></div>
    </div>
    <div class="faqs">
      <div class="heading">{{ $nippets.quote.faq }}</div>
      <openable-item>
        <template v-slot:header>{{ $nippets.quote.writtenBook }}</template>
        <span v-html="$nippets.quote.readOurGuide" v-on:click="$k.sendGaEvent('CommissioningGuide', 'Click', $store.state.lang)"></span>
      </openable-item>
      <openable-item>
        <template v-slot:header>{{ $nippets.quote.newToCom }}</template>
        {{ $nippets.quote.checkOut }}<ix-router-link to="/commissioning">{{ $nippets.quote.quickGuide}}</ix-router-link>
      </openable-item>
      <openable-item>
        <template v-slot:header>{{ $nippets.quote.areYouArtist }}</template>
        <div v-html="$nippets.quote.artistContact"></div>
      </openable-item>
    </div>
  </div>
</template>

<script>
import OpenableItem from './OpenableItem.vue'
import ContactsPanel from '../ContactsPanel.vue'
export default {
  components: {
    OpenableItem,
    ContactsPanel
  },
  props: {
    agent: Object
  },
  computed: {
    region () {
      return this.$store.state.lang.toLowerCase()
    },
    title () {
      if(!this.magent) {
        return this.$nippets.yourLocal
      }
      return this.magent.name
    }
    
  },
  data () {
    return {
      magent: null
    }
  },
  created () {
    this.magent = this.agent
  },
  methods: {
    reallySendEmail(agent){
      this.$emit('changeAgent', agent)
      this.magent = agent
    }
  },
  watch: {
    agent (){
      this.magent = this.agent
    }
  }
}
</script>

<style>

.rhs .heading {
  font-weight:500;
  margin-bottom:10px;
}

.rhs .heading.large{
  font-size: larger;
}

.rhs .heading.large.agent{
  font-size:23px;
  color:#ce0e2d;
}

.rhs .strong{
  font-weight:500;
}

.rhs .faqs{
  margin-top:30px;
}

.rhs .callus{
  margin-top:20px;
}
</style>